query specialMarketDetails($filter: SpecialMarketFilter) {
  allSpecialMarkets(filter: $filter) {
    nodes {
      competitions {
        nodes {
          competitionId
          competitionName
        }
      }
      events {
        nodes {
          eventId
          eventName
        }
      }
      sports {
        nodes {
          sportId
          sportName
        }
      }
      specialName
      specialId
      selections
      resultingStatus
      resultedAfter
      offeringStatus
      playerIds
      teamIds
      seasonIds
      suspensionTimestamps
      blockSpecialWith
      displayStatus
    }
  }
}
